import React from "react";
import { useRecordContext, useTranslate } from "react-admin";
import Typography from "@mui/material/Typography";
import { DateTime } from "luxon";

type Props = {
  source: "wholesaler_agreement_status";
  sortable?: boolean;
  showTime?: boolean;
};

export const WholesalerAgreementStatusField = (props: Props) => {
  const translate = useTranslate();
  const record = useRecordContext();
  const { showTime } = props;
  if (!record) {
    return null;
  }

  const { resubmit_requested_at, wholesaler_agreement_at, wholesaler_agreement_status } = record;

  let text = translate(`commons.agreement_statuses.${wholesaler_agreement_status}`);

  // 再提示がされている場合は再提示と表示する
  if (resubmit_requested_at) {
    text = "再提示";
  }

  if (showTime === true) {
    const time = DateTime.fromISO(wholesaler_agreement_at);
    return (
      <Typography variant="body2">
        {text}
        {time.isValid && (
          <Typography variant="caption" display="inline" style={{ marginLeft: "1em" }}>
            {time.toFormat("yyyy/LL/dd HH:mm:ss")}
          </Typography>
        )}
      </Typography>
    );
  }

  return <Typography variant="body2">{text}</Typography>;
};
